import { render, staticRenderFns } from "./Usertypemanage.vue?vue&type=template&id=46f6cc95&scoped=true"
import script from "./Usertypemanage.vue?vue&type=script&lang=js"
export * from "./Usertypemanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6cc95",
  null
  
)

export default component.exports